import { useState } from "react";

export function useRequestGroups() {
  const [groups, setGroups] = useState([]);
  const [pending, setPending] = useState(false);

  const isDragDisabled = !!groups.some((g) => g.isEditing);

  const addGroup = () => {
    setGroups((prev) => [
      ...prev,
      {
        id: `temp-${Date.now()}`,
        name: "",
        fields: [],
        isEditing: true,
        isNew: true,
      },
    ]);
  };

  const removeGroupLocal = (id) => {
    setGroups((prev) => prev.filter((g) => g.id !== id));
  };

  const toggleEdit = (id, value) => {
    setGroups((prev) =>
      prev.map((g) => (g.id === id ? { ...g, isEditing: value } : g)),
    );
  };

  return {
    groups,
    setGroups,
    pending,
    setPending,
    isDragDisabled,
    addGroup,
    removeGroupLocal,
    toggleEdit,
  };
}